module.exports = __webpack_public_path__ + "img/home-delivery-date-top-img_small@2x.2185d03c.jpg";